// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AuthorizedActions{align-items:center;display:flex;flex-direction:row;height:100%;justify-content:flex-end}.AuthorizedActions a:link{display:flex!important}@media only screen and (max-width:959px){.AuthorizedActions{padding-right:0!important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
